/* eslint-disable react/prop-types */
import React from 'react';

import DraggableContainer from './DraggableContainer';

const DayView = ({ scrollContainerRef }) => (
  <DraggableContainer
    id='programmedCalendarItems'
    scrollContainerRef={scrollContainerRef}
  />
);

export default DayView;
